export default "__VITE_ASSET__fvmiqVgC__"